import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import {Table, TR, TH, TD} from '@ag-media/react-pdf-table';
import { GOAL_TRACK_PARAMETERS_COLORS } from "config/constants";


const styles = StyleSheet.create({
  attendanceContainer: {
    ...globalStyles.standardBorder,
    // padding: 10,
    borderRadius: 5,
    flexDirection: "row",
    justifyContent: "space-evenly"
  },
  attendanceOuter: {
    alignItems: "center",
    padding: 15
  },
  attendanceLabel: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    marginBottom: 5
  },
  goalSelectionOuter: {
    paddingVertical: 10,
    paddingHorizontal: 30,
    backgroundColor: "#f6f6f6"
  },
  separatorLine: {
    ...globalStyles.standardBorder,
    // width: 1,
    height: '100%',
    // backgroundColor: 'black',
    alignSelf: 'center',
  },
  squareIcon: {
    width: 5,
    height: 5,
    backgroundColor: "rgb(61, 160, 170)",
  },
  goalReviewOuter: {
    backgroundColor: "#fbfbe6",
    padding: "20px",
    // marginBottom: "20px",
    borderRadius: "5px",
  },
  chartLegendsOuter: {
    backgroundColor: "#ebebd0",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: "5px",
  }
})

const TreatmentSummaryGoalsPreviewPdf = ({ data, notes, images = [] }) => {
  const { attendance, chart_data, period, selected_goals } = data?.answer?.other_details || {};
  const { absent, present, totalSessions } = attendance || {};

  return (
    <View>
      <View style={globalStyles.reportQuestionOuter} fixed>
        <Text style={globalStyles.reportQuestion}>
          Attendance
        </Text>
        <View
          style={styles.attendanceContainer}
          wrap={false}
        >
          <View style={styles.attendanceOuter}>
            <View style={styles.attendanceLabel}>
              <View
                style={styles.squareIcon}
              >
              </View>
              <Text style={globalStyles.fontBold}>
                Absent ({Math.round(absent?.percentage || 0)}%)
              </Text>
            </View>
            <Text>
              {`${absent?.count || 0}/${totalSessions || 0} Sessions`}
            </Text>
          </View>

          <View style={styles.separatorLine}></View>

          <View style={styles.attendanceOuter}>
            <View style={styles.attendanceLabel}>
              <View
                style={styles.squareIcon}
              >
              </View>
              <Text style={globalStyles.fontBold}>
                Present ({Math.round(present?.percentage || 0)}%)
              </Text>
            </View>
            <Text>
              {`${present?.count || 0}/${totalSessions || 0} Sessions`}
            </Text>
          </View>
        </View>
      </View>
      {selected_goals?.length > 0 ? 
      <View style={globalStyles.reportQuestionOuter}>
        <View style={styles.goalSelectionOuter}>
          <Text style={globalStyles.reportQuestion}>
            Select Data to Graph
          </Text>
          <Table style={[globalStyles.tableCommon, { border: "none" }]} wrap={false}>
            <TH style={globalStyles.standardBorder}>
              {selected_goals?.map((_, index) => (
                <TD key={index} style={globalStyles.tHeadCommon}>
                  <View style={[styles.attendanceLabel, { marginBottom: 0 }]}>
                    <View
                      style={styles.squareIcon}
                    >
                    </View>
                    <Text style={globalStyles.fontBold}>
                      Goal
                    </Text>
                  </View>
                </TD>
              ))}
            </TH>
            <TR style={globalStyles.standardBorder}>
              {selected_goals?.map((goalId, index) => {
                let goal = chart_data[goalId]?.goalData;
                return (
                  <TD style={globalStyles.tColCommon}>{goal?.assesmentGoalDetail?.title}</TD>
                )
              })}
            </TR>
          </Table>
        </View>
      </View>
      :''}
      <View style={globalStyles.reportQuestionOuter}>
        {selected_goals?.length > 0 && selected_goals.map((goalId, index) => {
          const goal = chart_data[goalId]?.goalData;
          const goalReview = 
            notes?.answer?.other_details?.goal_notes &&
            notes?.answer?.other_details?.goal_notes[goalId];
          const chartData = chart_data[goalId]?.chartData;
          const { series } = chartData;
          return (
            <>
              <View style={styles.goalReviewOuter} wrap={false}>

                {/* Goal Detail Table */}
                <View style={[globalStyles.table, globalStyles.reportQuestionOuter, { paddingTop: "0", width: "60%" }]}>
                  <View style={globalStyles.tableRow}>
                    <Text style={[globalStyles.tableHead, { width: "10%" }]}>{index + 1}.</Text>
                    <Text style={[globalStyles.tableHead, { width: "30%" }]}>Area</Text>
                    <Text style={[globalStyles.tableHead, { width: "60%" }]}>Goal</Text>
                  </View>
                  <View style={globalStyles.tableRow}>
                    <Text style={[globalStyles.tableColumn, { width: "10%" }]}></Text>
                    <Text style={[globalStyles.tableColumn, { width: "30%" }]}>
                      {goal?.assesmentGoalDisciplineArea?.name}
                    </Text>
                    <Text style={[globalStyles.tableColumn, { width: "60%" }]}>
                      {goal?.assesmentGoalDetail?.title}
                    </Text>
                  </View>
                </View>

                {/* Goal Tracking chart and Legends */}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center"
                  }}
                >
                  {/* Chart Image */}
                  <View style={{ width: "70%" }}>
                    <Image
                      style={{ width: "100%" }}
                      src={images[index]}
                    />
                  </View>
                  <View style={{ width: "30%" }}>

                    {/* Chart Legends */}
                    <View style={styles.chartLegendsOuter}>
                      {series?.length && series.map((param, index) => {
                        let paramColor = GOAL_TRACK_PARAMETERS_COLORS[param.name];
                        return (
                          <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingVertical: 5 }}>
                            <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
                              <View style={{
                                border: `2px solid ${paramColor}`,
                                borderRadius: "50%",
                                width: 20,
                                height: 20,
                                backgroundColor: "#fff",
                                alignItems: "center",
                                justifyContent: "center",
                              }}>
                                <Text style={[globalStyles.fontBold, { fontSize: 8 }]}>
                                  {param.name}
                                </Text>
                              </View>
                              <Text style={[globalStyles.fontBold, { fontSize: 8 }]}>
                                {param.name}
                              </Text>
                            </View>
                            <View style={{
                              width: 20,
                              height: 3,
                              backgroundColor: paramColor
                            }}>
                            </View>
                          </View>
                        )
                      })}
                    </View>
                  </View>
                </View>
              </View>
              <View style={globalStyles.reportQuestionOuter}>
                <Text style={globalStyles.reportQuestion}>
                  Goal Review
                </Text>
                {goalReview?.other_details?.radio_tag && (
                  <View
                    style={{
                      marginBottom: "5px",
                      alignSelf: "flex-start",
                    }}
                  >
                    <Text
                      style={{
                        ...globalStyles.fontBold,
                        backgroundColor: "#BEF9FF",
                        padding: "5px 10px",
                        borderRadius: "10px",
                        display: "inline-block",
                      }}
                    >
                      {goalReview?.other_details?.radio_tag}
                    </Text>
                  </View>
                )}
                <Text>
                  {goalReview?.answer}
                </Text>
              </View>
            </>
          )
        })}
      </View>
      
    </View>
  )
}

export default TreatmentSummaryGoalsPreviewPdf;